import React, { useState, useEffect } from "react";
import "./Financials.css";
import * as FeatherIcon from "react-feather";
import MicroChart from "../../../HtmlElements/MicroChart";

export default function CashFlow({ records = [], requiredValue }) {

  if (!records || Object.keys(records).length === 0) {
  //  return <div></div>;
  }

  const cash_flows = {
    "IQ_NI_CF" : "Net Income",
    "IQ_DA_SUPPL_CF" : "Depreciation & Amort.",
    "IQ_DA_CF" : "Depreciation & Amort., Total",
    "IQ_DO_CF" : "Net Cash from Discontinued Ops.",
    "IQ_OTHER_OPER_ACT" : "Other Operating Activities",
    "IQ_CHANGE_AR" : "Change in Acc. Receivable",
    "IQ_CHANGE_INVENTORY" : "Change in Inventories",
    "IQ_CHANGE_AP" : "Change in Acc. Payable",
    "IQ_CHANGE_INC_TAX" : "Change in Inc. Taxes",
    "IQ_CHANGE_OTHER_NET_OPER_ASSETS" : "Change in Other Net Operating Assets",
    "IQ_CASH_OPER" : "Cash from Operations",
    "IQ_CAPEX" : "Capital Expenditure",
    "IQ_SALE_PPE_CF" : "Sale of Property, Plant and Equipment",
    "IQ_CASH_ACQUIRE_CF" : "Cash Acquisitions",
    "IQ_DIVEST_CF" : "Divestitures",
    "IQ_INVEST_SECURITY_CF" : "Invest. In Marketable & Equity Securities",
    "IQ_INVEST_LOANS_CF" : "Net (Increase) Dec. in Loans Originated/Sold - Investing",
    "IQ_OTHER_INVEST_ACT_SUPPL" : "Other Investing Activities",
    "IQ_CASH_INVEST" : "Cash from Investing",
    "IQ_ST_DEBT_ISSUED" : "Short-Term Debt Issued",
    "IQ_LT_DEBT_ISSUED" : "Long-Term Debt Issued",
    "IQ_TOTAL_DEBT_ISSUED" : "Total Debt Issued",
    "IQ_ST_DEBT_REPAID" : "Short-Term Debt Repaid",
    "IQ_LT_DEBT_REPAID" : "Long-Term Debt Repaid",
    "IQ_TOTAL_DEBT_REPAID" : "Total Debt Repaid",
    "IQ_COMMON_REP" : "Repurchase of Common Stock",
    "IQ_COMMON_DIV_CF" : "Common Dividends Paid",
    "IQ_TOTAL_DIV_PAID_CF" : "Total Dividends Paid",
    "IQ_SPECIAL_DIV_CF" : "Special Dividend Paid",
    "IQ_OTHER_FINANCE_ACT_SUPPL" : "Other Financing Activities",
    "IQ_CASH_FINAN" : "Cash from Financing",
    "IQ_FX" : "Foreign Exchange Rate Adj.",
    "IQ_NET_CHANGE" : "Net Change in Cash",
    "IQ_CASH_INTEREST" : "Cash Interest Paid",
    "IQ_CASH_TAXES" : "Cash Taxes Paid",
    "IQ_LEVERED_CF" : "Levered Free Cash Flow",
    "IQ_UNLEVERED_FCF" : "Unlevered Free Cash Flow",
    "IQ_CHANGE_NET_WORKING_CAPITAL" : "Change in Net Working Capital",
    "IQ_NET_DEBT_ISSUED" : "Net Debt Issued",
    "IQ_FILINGDATE_CF" : "Filing Date"
    // "IQ_RESTATEMENT_CF" : "Restatment Type",
    // "IQ_CALC_TYPE_CF" : "Calculation Type"
  };

  const recordsArray = Array.isArray(records) ? records : [];
  const latestYears = Array.from(
    new Set(recordsArray.flatMap(record => record.data.map(item => item.year)))
  )
    .sort((a, b) => b - a)
    .slice(0, 5)
    .reverse();

  // NEW: Filter out year columns where every displayed row value is n.a. or 0
  const isValueEmpty = (value) =>
    value === "" || value === "Data Unavailable" || value === 0 || value === undefined || value === null;
  const visibleYears = latestYears.filter(year => {
    const fieldKeys = new Set(Object.keys(cash_flows));
    const relevantRecords = recordsArray.filter(r => fieldKeys.has(r._id));
    return relevantRecords.some(record => {
      const item = record.data.find(d => d.year === year);
      return item !== undefined && !isValueEmpty(item.value);
    });
  });
  // OLD: const yearsToRender = latestYears;
  const yearsToRender = visibleYears;

  return (
    <>
      {
        <div className="col-md-12 mb-2 mt-2">
            <div className="custom_card_block">
              <div className='quarterly_result_block'>
                <div className="head_top">
                  <h5 className="main_head">Cash Flows</h5>
                  <p className='main_head_para'>Consolidated Figures in $Mn 
                  {/* / <span className='blue_text'>View Standalone</span> */}
                  </p>
                </div>
                <div className='quater_table_block'>

                  {latestYears.length <= 0 &&
                  <div className='row'>
                    <div className='col-md-12'>
                      <div className="alert alert-warning" role="alert">
                      Complete financials are only available in paid version.
                      </div>
                    </div>
                  </div>
                  }

                  {latestYears.length > 0 &&
                  <div className='table-responsive custom_table_qut'>
                    <table className="custom-resizable-table quater_table">
                        <thead className='quater_table_thead'>
                          <tr className='quater_table_tr custom-resizable-table-header'>
                            {/* <th className='quater_table_th'></th>
                            <th className='quater_table_th'>2019</th>
                            <th className='quater_table_th'>2020</th>
                            <th className='quater_table_th'>2021</th>
                            <th className='quater_table_th'>2022</th>
                            <th className='quater_table_th'>2023</th>
                            <th className="quater_table_th text-center" style={{width: '110px'}}>5-Year Trend</th> */}
                            <th className="quater_table_th"></th>
                            {/* OLD: {latestYears.map(year => ( <th> ))} */}
                            {yearsToRender.map(year => (
                              <th key={year} className="quater_table_th"><div className="custom-resizable-table-th-content">{year}</div></th>
                            ))}
                            <th className="quater_table_th text-center" style={{ width: '110px' }}><div className="custom-resizable-table-th-content">5-Year Trend</div></th>
                          </tr>
                        </thead>

                        <tbody className="quater_table_tbody">
                          {Object.entries(cash_flows).map(([key, label]) => {
                            const record = records.find(item => item._id === key);
                            if (!record) return null;

                            const yearDataMap = Object.fromEntries(record.data.map(item => [item.year, item.value]));
                            // OLD: const chartData = latestYears.map(year => ({ category: year, value: parseFloat(yearDataMap[year] || 0) }));
                            const chartData = yearsToRender.map(year => ({ category: year, value: parseFloat(yearDataMap[year] || 0) }));

                            return (
                              <tr className="quater_table_tr dimension-row cursor-pointer gtr-row" key={key}>
                                <td className="quater_table_td_left gtr-cell"><div className="gtr-cell-content-container">{label}</div></td>
                                {/* OLD: {latestYears.map(year => ( <td> ))} */}
                                {yearsToRender.map(year => (
                                  <td key={year} className="quater_table_td gtr-cell">
                                                                      <div className="gtr-cell-content-container">

                                    {yearDataMap[year] < 0 ? (
                                      <span style={{ color: "red" }}>{requiredValue(yearDataMap[year])}</span>
                                    ) : (
                                      requiredValue(yearDataMap[year])
                                    )}
                                    </div>
                                  </td>
                                ))}
                                <td className="quater_table_td text-center gtr-cell">
                                <div className="gtr-cell-content-container">
                              <MicroChart data={chartData} chartType='bar' />
                              </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>

                      </table>
                  </div>
                  }
                </div>
              </div>
            </div>
        </div>
      }
    </>
  );
}
